module.exports = __webpack_public_path__ + "static/media/huli_205.0b638908.gif";